<script setup>
  //TODO Scroll Smooth
  //TODO loading
import { onMounted } from 'vue'
import { useCartStore } from '~/stores/cartStore'
import { useAuthStore } from '@/stores/authStore'
const authStore = useAuthStore()
const cartStore = useCartStore()
//const isLoading = ref(true);
// We use onMounted to ensure this runs only on the client side
// This prevents hydration mismatches if using localStorage
onMounted(async () => {
    // Run them in parallel for better performance, or sequentially if dependent
    await Promise.all([
        cartStore.initializeCart(),
        authStore.fetchUser() // 3. Optional: Validate token/refresh user data
    ])
})
</script>
<template>
  <NuxtLayout>
    <NuxtPage />
    <TheToaster />  
  </NuxtLayout>
</template>
<style scoped>

</style>